var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "show-close": true,
            title: _vm.$t("fixDutyFine.reportedEvent"),
            visible: _vm.addDialog,
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialog = $event
            },
            close: function ($event) {
              return _vm.resetForm("ruleForm")
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.eventCategory"),
                            prop: "eventType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              on: { change: _vm.changeEventType },
                              model: {
                                value: _vm.ruleForm.eventType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "eventType", $$v)
                                },
                                expression: "ruleForm.eventType",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("fixDutyFine.abnormalEvent"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("fixDutyFine.theftEvent"),
                                  value: 2,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.abnormalityType"),
                            prop: "exceptionType",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.ruleForm.exceptionType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "exceptionType", $$v)
                                },
                                expression: "ruleForm.exceptionType",
                              },
                            },
                            _vm._l(_vm.exceptionTypeList, function (item) {
                              return _c("el-option", {
                                key: item.type,
                                attrs: {
                                  label: item.typeName,
                                  value: item.type,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.abnormalityLevel"),
                            prop: "exceptionLevel",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: _vm.ruleForm.exceptionLevel,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "exceptionLevel", $$v)
                                },
                                expression: "ruleForm.exceptionLevel",
                              },
                            },
                            [
                              _c("el-option", {
                                key: "1",
                                attrs: {
                                  label: _vm.$t("fixDutyFine.high"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                key: "2",
                                attrs: {
                                  label: _vm.$t("fixDutyFine.medium"),
                                  value: 2,
                                },
                              }),
                              _c("el-option", {
                                key: "3",
                                attrs: {
                                  label: _vm.$t("fixDutyFine.low"),
                                  value: 3,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.estimatedLossAmount"),
                            prop: "financeLoss",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              clearable: "",
                            },
                            model: {
                              value: _vm.ruleForm.financeLoss,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "financeLoss", $$v)
                              },
                              expression: "ruleForm.financeLoss",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.affectedPackageDetails"),
                            prop: "packageDetail",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              rows: 3,
                              type: "textarea",
                            },
                            model: {
                              value: _vm.ruleForm.packageDetail,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "packageDetail", $$v)
                              },
                              expression: "ruleForm.packageDetail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.abnormalityDescription"),
                            prop: "exceptionDetail",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: 1000,
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              rows: 3,
                              "show-word-limit": "",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.ruleForm.exceptionDetail,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "exceptionDetail", $$v)
                              },
                              expression: "ruleForm.exceptionDetail",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.casualtyCount"),
                            prop: "lossPeopleQuantity",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("GlobalSetObj.pleaseInput"),
                              clearable: "",
                              maxlength: "9",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.ruleForm.lossPeopleQuantity,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.ruleForm,
                                  "lossPeopleQuantity",
                                  $$v
                                )
                              },
                              expression: "ruleForm.lossPeopleQuantity",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.ruleForm.eventType === 2
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("fixDutyFine.hasMDFE"),
                                prop: "mdfeInvoice",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.mdfeInvoice,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "mdfeInvoice", $$v)
                                    },
                                    expression: "ruleForm.mdfeInvoice",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.yes"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "2",
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.No"),
                                      value: 0,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.ruleForm.eventType === 2
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("fixDutyFine.hasPoliceReceipt"),
                                prop: "policeReceipt",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.policeReceipt,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "policeReceipt",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.policeReceipt",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.yes"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "2",
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.No"),
                                      value: 0,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.ruleForm.eventType === 2
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("fixDutyFine.hasElectronicLock"),
                                prop: "electronicLock",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.ruleForm.electronicLock,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ruleForm,
                                        "electronicLock",
                                        $$v
                                      )
                                    },
                                    expression: "ruleForm.electronicLock",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    key: "1",
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.yes"),
                                      value: 1,
                                    },
                                  }),
                                  _c("el-option", {
                                    key: "2",
                                    attrs: {
                                      label: _vm.$t("GlobalSetObj.No"),
                                      value: 0,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("fixDutyFine.addPhotos"),
                            prop: "photograph",
                          },
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "uploadRef",
                              attrs: {
                                "before-upload": _vm.beforeAvatarUpload,
                                "file-list": _vm.imageList,
                                "http-request": _vm.upLoad,
                                limit: 6,
                                "on-change": _vm.handleChangeFile,
                                "on-exceed": _vm.handleExceed,
                                "on-remove": _vm.handleDeleteImgRemove,
                                action: "#",
                                "list-type": "picture-card",
                                multiple: "",
                              },
                              model: {
                                value: _vm.ruleForm.photograph,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "photograph", $$v)
                                },
                                expression: "ruleForm.photograph",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-plus avatar-uploader-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticStyle: { color: "#606266" } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("fixDutyFine.uploadImageLimit")) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.resetForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("roleManage.cancel")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { loading: _vm.loadingBtn, type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("roleManage.confirm")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }